export const isDevEnvironment = !![
  "https://alpha.jobbliss.com",
  // "https://staging.d2trb6ppn7b4rn.amplifyapp.com",
  "http://localhost:3000",
].find((a) => a === window.location.origin);
export const APP_MAINTENANCE_KEY = "aGceR8AUTgzP5c0X820M";
